var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      ref: "modal",
      staticClass: "prp-terms-modal",
      attrs: { id: "modal-demo" },
      on: {
        hide: function($event) {
          return _vm.cancelModal()
        }
      },
      model: {
        value: _vm.open,
        callback: function($$v) {
          _vm.open = $$v
        },
        expression: "open"
      }
    },
    [
      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
        _c(
          "a",
          {
            staticClass: "close",
            on: {
              click: function($event) {
                return _vm.cancelModal()
              }
            }
          },
          [
            _c("i", {
              staticClass: "typcn typcn-delete",
              attrs: { "aria-hidden": "true" }
            })
          ]
        ),
        _vm._v(" "),
        _c("h3", [
          _c("i", {
            staticClass: "typcn typcn-document-text",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(_vm._s(_vm.$t("ORP_TERMS_MODAL_HEADER")) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "panel panel-default" }, [
          _c("div", { staticClass: "panel-body" }, [
            _c("p", { staticClass: "prp-terms-text" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.orpDetails.termsAndConditions) +
                  "\n        "
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c("button", {
          directives: [
            { name: "t", rawName: "v-t", value: "CLOSE", expression: "'CLOSE'" }
          ],
          staticClass: "button button--white-hover-grad pulse",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.cancelModal()
            }
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }